import React, { useEffect, useState, useRef } from 'react';
const COUNTDOWN_MINUTES = 15;
const COUNTDOWN_KEY = 'promo_countdown_end';
function getOrCreateEndTime(): number {
  const stored = sessionStorage.getItem(COUNTDOWN_KEY);
  if (stored) {
    const end = parseInt(stored, 10);
    if (end > Date.now()) return end;
  }
  const end = Date.now() + COUNTDOWN_MINUTES * 60 * 1000;
  sessionStorage.setItem(COUNTDOWN_KEY, end.toString());
  return end;
}
function getTimeLeft(endTime: number) {
  const diff = endTime - Date.now();
  if (diff <= 0) return {
    minutes: 0,
    seconds: 0
  };
  return {
    minutes: Math.floor(diff / 60000),
    seconds: Math.floor(diff % 60000 / 1000)
  };
}
function pad(n: number) {
  return n.toString().padStart(2, '0');
}
export function PromoBanner() {
  const endTimeRef = useRef(getOrCreateEndTime());
  const [time, setTime] = useState(() => getTimeLeft(endTimeRef.current));
  useEffect(() => {
    const interval = setInterval(() => {
      const left = getTimeLeft(endTimeRef.current);
      if (left.minutes === 0 && left.seconds === 0) {
        // Reset the timer
        const newEnd = Date.now() + COUNTDOWN_MINUTES * 60 * 1000;
        sessionStorage.setItem(COUNTDOWN_KEY, newEnd.toString());
        endTimeRef.current = newEnd;
      }
      setTime(getTimeLeft(endTimeRef.current));
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-center px-4 py-2 border-b border-black/5 gap-3" style={{
    backgroundColor: '#F0EBE1',
    minHeight: 60
  }} data-id="element-231">
      <div className="flex flex-col items-center" data-id="element-232">
        <p className="text-charcoal font-semibold text-sm leading-tight text-center m-0" data-id="element-233">
          🔥 OFERTA DE LANZAMIENTO: Quedan solo{' '}
          <span className="text-[#E67E22] font-bold" data-id="element-234">14 cupos</span> a $4.990
        </p>
        <div className="flex items-center gap-2 mt-0.5" data-id="element-235">
          <p className="text-charcoal/50 text-xs leading-tight text-center m-0 font-normal" data-id="element-236">
            Vuelve a $19.990 en
          </p>
          <span className="inline-flex items-center bg-charcoal text-white text-xs font-bold px-2 py-0.5 rounded-md tracking-wider tabular-nums" data-id="element-237">
            {pad(time.minutes)}:{pad(time.seconds)}
          </span>
        </div>
      </div>
    </div>;
}